module.exports = __webpack_public_path__ + "d419ba509be4b5de02e59a50e28e64e8.MP3";